import * as actionTypes from './actionTypes';
import * as api from '../api';
import { calculateDateRange, getAjaxFunc, createActionObject } from '../../helpers/common';


export const setSelectedStationName = stationName => dispatch => dispatch(
    createActionObject(
      actionTypes.SELECT_STATION,
      { stationName }
    )
);

export const setSelectedDeviceName = deviceName => dispatch => dispatch(
    createActionObject(
      actionTypes.SELECT_DEVICE,
      { deviceName }
    )
);

export const selectView = view => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_VIEW_PERIOD,
        { view }
    )
);

export const selectDayStart = day => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_DAY_START,
        { day }
    )
)

export const selectMonthStart = month => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_MONTH_START,
        { month }
    )
);

export const selectYearStart = year => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_YEAR_START,
        { year }
    )
);

export const selectDayEnd = day => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_DAY_END,
        { day }
    )
)

export const selectMonthEnd = month => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_MONTH_END,
        { month }
    )
);

export const selectYearEnd = year => dispatch => dispatch(
    createActionObject(
        actionTypes.SELECT_YEAR_END,
        { year }
    )
);

export const callDeviceFaultDetailsApi = () => (dispatch, getState) => {
    const state = getState(); // Get the current state
  
    // Extract necessary state data
    const { selectedView, selectedYear, selectedMonth, selectedDay } = state.systemDeviceFaults;
    const stationName = state.systemDeviceFaults.selectedStationName;
  
    // Calculate date range
    const { startDate, endDate } = calculateDateRange(selectedView, selectedYear, selectedMonth, selectedDay);
  
    // Construct the payload for the details API call
    const payload = {
      stationName,
      startDate,
      endDate,
    };
  
    // API call for the details
    api.getDeviceFaultDetails(payload) 
        .then(({ data, status }) => {
        if (status === 200) {
            dispatch(
            createActionObject(
                actionTypes.GET_SYSTEM_DEVICE_FAULT_DETAILS, 
                { data: data }
            )
            );
        } else if (status === 500) {
            dispatch(
            createActionObject(
                actionTypes.SYSTEM_DEVICE_FAULT_DETAILS_FAILURE,
                { data: null }
            )
            );
        }
    }).catch(error => {
        console.error("Fetching device fault details failed:", error);
    });
};

export const callDeviceFaultCountApi = () => (dispatch, getState) => {
    const state = getState(); // Get the current state
  
    // Extract necessary state data
    const { selectedView, selectedYear, selectedMonth, selectedDay } = state.systemDeviceFaults;
    const stationName = state.systemDeviceFaults.selectedStationName;
  
    // Calculate date range
    const { startDate, endDate } = calculateDateRange(selectedView, selectedYear, selectedMonth, selectedDay);
  
    // Construct the payload for the count API call
    const payload = {
      stationName,
      startDate,
      endDate,
    };
  
    // API call for the Count
    api.getDeviceFaultCount(payload) 
        .then(({ data, status }) => {
        if (status === 200) {
            dispatch(
            createActionObject(
                actionTypes.GET_SYSTEM_DEVICE_FAULT_COUNT, 
                { data: data }
            )
            );
        } else if (status === 500) {
            dispatch(
            createActionObject(
                actionTypes.SYSTEM_DEVICE_FAULT_DETAILS_COUNT,
                { data: null }
            )
            );
        }
    }).catch(error => {
        console.error("Fetching device fault count failed:", error);
    });
};

export const callDeviceFaultSummaryApi = () => (dispatch, getState) => {
    const state = getState(); // Get the current state
  
    // Extract necessary state data
    const { selectedView, selectedYear, selectedMonth, selectedDay } = state.systemDeviceFaults;
    const stationName = state.systemDeviceFaults.selectedStationName;
  
    // Calculate date range
    const { startDate, endDate } = calculateDateRange(selectedView, selectedYear, selectedMonth, selectedDay);
  
    // Construct the payload
    const payload = {
      stationName,
      startDate,
      endDate,
    };
  
    // console.log("payload", payload);
    // // API call
    api.getDeviceFaultSummary(payload)
        .then(({ data, status }) => {
        if (status === 200) {
            dispatch(
            createActionObject(
                actionTypes.GET_SYSTEM_DEVICE_FAULT_SUMMARY,
                { data: data }
            )
            );
        } else if (status === 500) {
            dispatch(
            createActionObject(
                actionTypes.SYSTEM_DEVICE_FAULT_SUMMARY_FAILURE,
                { data: null }
            )
            );
        }
    });
  };

  export const fetchStationDeviceFaultDeviceListInfo = (stationName) => dispatch => {
    dispatch({ type: actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_REQUEST });

    api.getStationDeviceFaultDeviceListInfo({ stationName })
        .then(response => {
            if (response.status === 200) {
                // Corrected to use response.data
                dispatch(
                    createActionObject(
                        actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_SUCCESS,
                        { data: response.data } // Correctly accessing data from the response
                    )
                );
            } else if (response.status === 404) {
                dispatch(
                    createActionObject(
                        actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_FAILURE,
                        { error: response.message || "No data available for the requested station." }
                    )
                );
            }
        })
        .catch(error => {
            dispatch(
                createActionObject(
                    actionTypes.FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_FAILURE,
                    { error: error.message || "An error occurred while fetching the station device error device list." }
                )
            );
        });
};

export const fetchStationDeviceFaultDatesInfo = (requestData) => dispatch => {
    dispatch({ type: actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_REQUEST });

    // Ensure requestData is correctly structured as expected by the API
    api.getStationDeviceFaultDatesInfo(requestData)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_SUCCESS,
                    data: response.data // Ensure that this matches how your actual API response is structured
                });
            }
        })
        .catch(error => {
            dispatch({
                type: actionTypes.FETCH_STATION_DEVICE_FAULT_DATES_FAILURE,
                error: error.message || "An error occurred while fetching station device date information."
            });
        });
};
//prev
// export const fetchQueryDeviceFaultData = (requestData) => dispatch => getAjaxFunc(
//     actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST,
//     "",
//     actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE,
//     "",
//     dispatch
//   )(
//     () => api.queryDeviceFaultData(requestData)
//       .then(({ data, status }) => {
//         if (status === 200) {
//           // Log the data before dispatching the success action
//           dispatch(
//             createActionObject(
//               actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS,
//               { queryDeviceFaultData: data }
//             )
//           )
//         }
//       })
// )()

export const fetchQueryDeviceFaultData = (requestData) => dispatch => getAjaxFunc(
    actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST,
    "",
    actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE,
    "",
    dispatch
)(
    () => api.queryDeviceFaultData(requestData)
        .then(({ data, status }) => {
            if (status === 200) {
                // console.log("Raw API Data:", data); // Log raw data to check its format
                let formattedData = data
                .replace(/=/g, ':')
                .replace(/([{,]\s*)(\w+)(\s*:\s*["'{}[\w])/g, '$1"$2"$3')
                .replace(/([{,]\s*".+?"\s*:\s*)([^"{}\[\],\s].*?)([,\s}])/g, function (match, p1, p2, p3) {
                    if (/^\d+$/.test(p2)) {  // Check if p2 is a numeric value
                        return `${p1}${p2}${p3}`;  // Return without quotes if numeric
                    }
                    return `${p1}"${p2.replace(/"/g, '\\"')}"${p3}`;  // Quote if not numeric
                });
                                        
                                        
                // console.log("Formatted Data:", formattedData);

                try {
                    const jsonData = JSON.parse(formattedData);
                    // console.log("JSON Data:", jsonData);

                    dispatch(
                        createActionObject(
                            actionTypes.FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS,
                            { queryDeviceFaultData: jsonData }
                        )
                    );
                } catch (error) {
                    console.error("Error parsing data from API:", error);
                }
            }
        })
)();